import ApiService from '../api.services';

const PdvCashierService = {
    status: async function () {
        try {
            const response = await ApiService.get(`/api/pdv/cashier/status`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    open: async function (value) {
        try {
            const response = await ApiService.patch(`/api/pdv/open`, {
                value
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    info: async function () {
        try {
            const response = await ApiService.get(`/api/pdv/cashier/info`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    authorization: async function () {
        try {
            const response = await ApiService.get(`/api/pdv/cashier/authorization`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    myauthorization: async function () {
        try {
            const response = await ApiService.get(`/api/pdv/cashier/authorization/my`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    approveReprove: async function (type, list) {
        try {
            const data = {
                type,
                list
            }
            const response = await ApiService.post(`/api/pdv/cashier/authorization`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    request: async function (type) {
        try {
            const response = await ApiService.put(`/api/pdv/cashier/authorization`, {
                type
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    conference: async function (value) {
        try {
            const response = await ApiService.post(`/api/pdv/cashier/conference`, {
                value: value,
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    transaction: async function (data) {
        try {
            const response = await ApiService.post(`/api/pdv/cashier/transaction`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    close: async function () {
        try {
            const response = await ApiService.post(`/api/pdv/cashier/close`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default PdvCashierService;

export { PdvCashierService };

